<template>
  <b-modal id="organization-search-modal" ref="organization-search-modal" no-close-on-esc @hidden="resetModal" @close="resetModal">
    <template slot="modal-title"> {{ $t('searchSchool') }}
      <font-awesome-icon id="organizationSearchTip" icon="info-circle"/>
      <b-tooltip target="organizationSearchTip">{{ $t('toolTip.organizationSearchTip') }}</b-tooltip>
    </template>

    <b-form-group id="organization-search-group">
      <b-form-input size="sm" v-model.trim="searchName" :placeholder="$t('typeSchoolAndHitEnter')" type="text" :state="searchState" v-on:keyup="onKeyup"
                    autofocus/>
      <p/>
      <b-form-input size="sm" v-model.trim="searchNumber" :placeholder="$t('typeOrgNoAndHitEnter')" type="text" :state="searchState" v-on:keyup="onKeyup"/>
      <p/>
      <strong v-if="resultCountOrganizations === 0" class="text-info"> {{ $t('noResults') }}</strong>
      <b-form-invalid-feedback id="organization-feedback" v-if="searchName">
        {{ $t('nameValidation') }}
      </b-form-invalid-feedback>
      <div class="aco-dropdown-item" @click="selectOrganization(organization)" v-for="organization in organizations" :key="organization.organizationNumber">
        {{ organization.name }}, {{ organization.organizationNumber }} ({{ findOrganizationForm(organization.school, organization.schoolOwner) }})
      </div>
    </b-form-group>
    <div v-if="organizationNumber">
      <b-form-group id="organization-number-group" :label="$t('organizationNumber')" label-for="organizationNumber">
        <b-form-input size="sm" id="organizationNumber" type="text" v-model="organizationNumber" readonly/>
      </b-form-group>
      <b-form-group id="organization-name-group" :label="$t('organizationName')" label-for="organizationName">
        <b-form-input size="sm" id="organizationName" type="text" v-model="organizationName" readonly/>
      </b-form-group>
      <b-form-group id="organization-organizationType-group" :label="$t('organizationType')" label-for="school">
        <b-form-input size="sm" id="organizationType" type="text" v-model="organizationType" readonly/>
      </b-form-group>
    </div>
    <div slot="modal-footer" class="col-md-12">
      <b-button variant="primary" class="float-lg-right" v-on:click="submitOrganization" :disabled=disableUpdateButton>
        {{ $t('use') }}
      </b-button>
      <b-button variant="secondary" class="float-lg-left" v-on:click="resetModal">
        {{ $t('cancel') }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
  import OrganizationService from '../../src/services/OrganizationService'

  export default {
    name: 'OrganizationSearch',
    data () {
      return {
        searchName: null,
        searchNumber: null,
        organizations: [],
        selectedOrganization: {},
        organizationNumber: null,
        organizationName: null,
        school: null,
        isButtonDisabled: true,
        callback: null
      }
    },
    computed: {
      searchState () {
        return (this.searchName && this.searchName.length >= 3) || (this.searchNumber)
      },
      disableUpdateButton () {
        return (this.organizationName === null && this.organizationNumber === null && this.isButtonDisabled === true)
      },
      resultCountOrganizations () {
        return this.organizations && this.organizations.length
      },
      organizationType () {
        if (this.school) {
          return this.$t('school')
        }
        if (this.schoolOwner) {
          return this.$t('schoolOwner')
        }

        return this.$t('other')
      },
    },
    methods: {
      onKeyup (event) {
        if (event.which === 13) {
          if (!this.searchState) {
            return
          }
          this.searchOrganization()
        }
      },
      findOrganizationForm (school, schoolOwner) {
        if (school) {
          return this.$t('school')
        }
        if (schoolOwner) {
          return this.$t('schoolOwner')
        }

        return this.$t('other')
      },
      searchOrganization () {
        OrganizationService.searchOrganization(this.searchName, this.searchNumber)
          .then((response) => {
            this.organizations = response
          })
      },
      selectOrganization (org) {
        this.selectedOrganization = org
        this.organizations = ''
        this.organizationName = org.name
        this.organizationNumber = org.organizationNumber
        this.school = org.school
        this.schoolOwner = org.schoolOwner
        this.isButtonDisabled = false
      },
      submitOrganization () {
        this.callback(this.selectedOrganization)
        this.resetModal()
      },
      resetModal () {
        this.searchName = null
        this.searchNumber = null
        this.selectedOrganization = null
        this.organizations = null
        this.organizationName = null
        this.organizationNumber = null
        this.isButtonDisabled = true
        this.$refs['organization-search-modal'].hide()
      },
      showModal (variant) {
        if (variant !== undefined) {
          this.callback = variant
        }
        this.resetModal()
        this.$bvModal.show('organization-search-modal')
      }
    },
    i18n: {
      messages: {
        en: {
          'typeSchoolAndHitEnter': 'Type name and hit enter key',
          'typeOrgNoAndHitEnter': 'Type organization number and hit enter',
          'searchSchool': 'Search school',
          'nameValidation': 'Enter at least 3 letters',
        },
        nb: {
          'typeOrgNoAndHitEnter': 'Skriv inn organisasjonsnummer og trykk enter',
          'typeSchoolAndHitEnter': 'Skriv inn navn og trykk enter',
          'searchSchool': 'Skolesøk',
          'nameValidation': 'Skriv inn minst 3 tegn',
        }
      }
    }
  }
</script>
